/* eslint-disable react/prop-types */
import {
  Button,
  DialogContent,
  DialogContentText,
  Link,
  Stack,
} from "@mui/material";
import DialogHeader from "./dialogHeader";
import translations from "../translations";

export default function ErrorDialog({
  handlePrevious,
  handleClose,
  profileUrl,
}) {
  const locale = window.authSettings ? window.authSettings.locale : "fr-FR";
  const translation = translations.getTranslations(locale);
  return (
    <>
      <DialogHeader
        title={translation.errorDialog.title}
        handleClose={handleClose}
        isClosable={true}
      />
      <DialogContent sx={{ display: "flex", width: "-webkit-fill-available" }}>
        <Stack display={"flex"} width={"100%"}>
          <DialogContentText
            id="error-dialog-description"
            className="intelligent-profile-dialog-text"
            marginBottom={2}
            display={"flex"}
            fontSize={"16px"}
            style={{ whiteSpace: "pre-wrap" }}
          >
            {translation.errorDialog.description}
          </DialogContentText>
        </Stack>
      </DialogContent>
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={8}
        margin={3}
      >
        <Link href={`#/${profileUrl}`} onClick={handleClose}>
          {translation.errorDialog.navigation}
        </Link>
        <Button
          className="intelligent-profile-dialog-button"
          variant="contained"
          onClick={handlePrevious}
          data-dtm="exhibitorHub_smartCompanion_retry"
        >
          {translation.errorDialog.button}
        </Button>
      </Stack>
    </>
  );
}
